import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            瓜友热评
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">来自吃瓜群众的真实声音</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {commentItems.map((comment, idx) => (
            <div key={idx} className="p-5 rounded-lg bg-background-50 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center">
                  <span className="text-sm font-bold text-secondary-600">{comment.avatar}</span>
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-800">{comment.author}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-heart-line"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}